<template>
  <div class="container contract-item">
    <table style="width:100%;">
      <tr>
        <td>{{ $t('menu.itemName') }}</td>
        <td>
          <select class="normalInput normalSelect" ref="dcontract_select_box" @change="click({type:'change'})"> 
            <option v-for="(item, index) in itemList" :value="item.NAME.trim()" v-bind:key="index" >{{item.NAME.trim()}}</option>
          </select>
        </td>
        <td>주문수량</td>
        <td><input type="number normalSelect" class="normalInput normalSelect" ref="dcontract_amount" /></td>
      </tr>
      <tr>
        <td>{{ $t('menu.name') }}</td>
        <td><input type="text" class="normalInput normalSelect" ref="dcontract_orderName"/></td>
        <td>{{ $t('menu.phoneNumber') }}</td>
        <td><input type="text" class="normalInput normalSelect" ref="dcontract_phone"/></td>
      </tr>
      <tr>
        <td>{{ $t('menu.clearance') }}</td>
        <td><input type="text" class="normalInput normalSelect" ref="dcontract_clearance" /></td>
        <td>{{ $t('menu.zip') }}</td>
        <td><input type="text" class="normalInput normalSelect" ref="dcontract_zipcode"/></td>
      </tr>
      <tr>
        <td v-html="$t('menu.address2')"></td>
        <td><input type="text" class="normalInput normalSelect" ref="dcontract_addrRoad" /></td>
        <td>{{ $t('menu.address2') }}</td>
        <td><input type="text" class="normalInput normalSelect" ref="dcontract_addrDetail"/></td>
      </tr>
      <tr>
        <td>{{ $t('menu.brand') }}</td>
        <td><input type="text" class="normalInput normalSelect" ref="dcontract_brand" disabled/></td>
        <td>{{ $t('menu.country') }}</td>
        <td><input type="text" class="normalInput normalSelect" ref="dcontract_country" disabled/></td>
      </tr>
      <tr>
        <td>{{ $t('menu.fPrice') }}</td>
        <td><input type="text" class="normalInput normalSelect" ref="dcontract_fprice" disabled/></td>
        <td>{{ $t('menu.sPrice') }}</td>
        <td><input type="text" class="normalInput normalSelect" ref="dcontract_sprice" disabled/></td>
      </tr>
      <tr>
        <td style="border-left:0px;vertical-align: middle;">{{$t('menu.url')}}</td>
        <td colspan="3" style="border-right:0px; height:30px;vertical-align: middle;">
          <input type="text" class="normalInput normalSelect" ref="dcontract_url" disabled />
        </td>
      </tr>
      <tr>
        <td style="border-left:0px;vertical-align: middle;">{{ $t('menu.pictureUrl') }}</td>
        <td colspan="3" style="border-right:0px; height:30px;vertical-align: middle;">
          <input type="text" class="normalInput normalSelect" ref="dcontract_imgUrl" disabled />
        </td>
      </tr>
      <tr>
        <td style="border-left:0px;vertical-align: middle;">{{ $t('menu.etc') }}</td>
        <td colspan="3" style="border-right:0px; height:30px;vertical-align: middle;">
          <input type="text" class="normalInput normalSelect" ref="dcontract_content"/>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <Button style="margin-top:10px;float:none" @click="click({type:'add'})" label="추가" raised size="small" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  emits: ["setOrder"],
  setup() {
    const { t } = useI18n()

    return {
      t
    }
  },
  mounted() {
    this.emitter.on('dorder', this.reload)
    this.click({type:'change'})
  },
  unmounted() {
    this.emitter.off('dorder', this.reload)
  },
  components: {
  },  
  props: {
    itemList: ref([]),
  },
  data() { 
    return { 
      orderList:Array()
    } 
  },
  methods: {
    reload() {
      this.orderList = Array()
    },
    click(param) {
      const type = param.type
      if(type === 'change') {
        this.itemList.forEach((item) => {
          const selectedItemName = this.$refs.dcontract_select_box.value
          if (item.NAME.trim() === selectedItemName) {
            this.$refs.dcontract_brand.value = item.BRAND
            this.$refs.dcontract_country.value = item.COUNTRY
            this.$refs.dcontract_fprice.value = item.ORIGIN_PRICE
            this.$refs.dcontract_sprice.value = item.SELL_PRICE
            this.$refs.dcontract_url.value = item.URL
          }
        })
      } else if(type === 'add') {
        const orderName = this.$refs.dcontract_orderName.value
        const amount = this.$refs.dcontract_amount.value
        const phone = this.$refs.dcontract_phone.value
        const clearance = this.$refs.dcontract_clearance.value
        const zipcode = this.$refs.dcontract_zipcode.value
        const addrRoad = this.$refs.dcontract_addrRoad.value
        
        if(orderName === '') {
          alert(`${this.t('sentence.wrongInfo50')}`)
          this.$refs.dcontract_orderName.focus()
        } else if(phone === '') {
          alert(`${this.t('sentence.wrongInfo04')}`)
          this.$refs.dcontract_phone.focus()
        } else if(clearance === '') {
          alert(`${this.t('sentence.wrongInfo02')}`)
          this.$refs.dcontract_clearance.focus()
        } else if(amount === '') {
          alert(`${this.t('sentence.wrongInfo51')}`)
          this.$refs.dcontract_amount.focus()
        } else if(zipcode === '') {
          alert(`${this.t('sentence.wrongInfo52')}`)
          this.$refs.dcontract_zipcode.focus()
        } else if(addrRoad === '') {
          alert(`${this.t('sentence.wrongInfo53')}`)
          this.$refs.dcontract_addrRoad.focus()
        } else {
          let order = Array()
          const addrDetail = this.$refs.dcontract_addrDetail.value
          // const brand = this.$refs.dcontract_brand.value
          // const country = this.$refs.dcontract_country.value
          // const originPrice = this.$refs.dcontract_fprice.value
          // const sellPrice = this.$refs.dcontract_sprice.value
          // const url = this.$refs.dcontract_url.value
          // const imgUrl = this.$refs.dcontract_imgUrl.value
          const content = this.$refs.dcontract_content.value
          const itemName = this.$refs.dcontract_select_box.value
          order.push(itemName)
          order.push(amount)
          order.push(orderName)
          order.push(phone)
          order.push(clearance)
          order.push(zipcode)
          order.push(addrRoad)
          order.push(addrDetail)
          order.push(content)
          // order.push(imgUrl)
          this.orderList.push(order)
          this.$emit('setOrder', this.orderList)
          
          this.$refs.dcontract_orderName.value = ''
          this.$refs.dcontract_amount.value = ''
          this.$refs.dcontract_phone.value = ''
          this.$refs.dcontract_clearance.value = ''
          this.$refs.dcontract_zipcode.value = ''
          this.$refs.dcontract_addrRoad.value = ''
          this.$refs.dcontract_addrDetail.value = ''
          this.$refs.dcontract_content.value = ''
          return
        }
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
<style scoped>
.contract-item > table > tr > td:nth-child(odd) {
  font-weight: bold;
  min-width:100px;
  text-align:center;
  height:40px;
}
</style>
